import { Box } from "@mui/material";
import CardMedia from "../../../Media/CardMedia";
import {
  IMAGE_NO_CONTENT_TO_SHOW,
  NO_SUPPORTED_FILE,
} from "../../../../i18n/keysTranslations";

const SingleImagePreview = ({ item, isImage, isVideo, t }) => {
  if (!item?.url) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          color: "#666",
          fontSize: "1.1rem",
          textAlign: "center",
        }}
      >
        {t(IMAGE_NO_CONTENT_TO_SHOW)}
      </Box>
    );
  }

  if (isImage) {
    return (
      <Box
        component="img"
        src={item.url}
        alt="Content to share"
        sx={{
          maxWidth: "100%",
          maxHeight: "100%",
          width: "auto",
          height: "auto",
          objectFit: "contain",
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      />
    );
  }

  if (isVideo) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          maxWidth: "100%",
          maxHeight: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CardMedia
          url={item.url}
          propsType={{
            controls: true,
            controlsList: "nodownload",
            autoplay: false,
            loop: false,
            muted: true,
          }}
          sxVideo={{
            width: "auto",
            height: "100%",
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            borderRadius: 3,
            boxShadow: "none",
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        color: "#666",
        fontSize: "1.1rem",
        border: "2px dashed #ccc",
        borderRadius: 2,
        textAlign: "center",
      }}
    >
      {t(NO_SUPPORTED_FILE)}
    </Box>
  );
};

export default SingleImagePreview;
